import { render, staticRenderFns } from "./pjnoticeView.vue?vue&type=template&id=7116b370&scoped=true"
import script from "./pjnoticeView.vue?vue&type=script&lang=js"
export * from "./pjnoticeView.vue?vue&type=script&lang=js"
import style0 from "./pjnoticeView.vue?vue&type=style&index=0&id=7116b370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7116b370",
  null
  
)

export default component.exports